// src/config/navbarLinks.js
export const navbarLinks = [
  {
    title: 'nav.play',
    items: [
      {
        title: 'nav.poker',
        mobileTitle: "nav.playPoker",
        img: 'nav/poker-menu.jpg',
        imgAlt: 'nav.poker',
        items: [
          { categoryTitle: true, route: 'routes.poker', title: 'nav.poker', img: 'nav/poker-menu.jpg', imgAlt: 'nav.poker', icon: 'poker' },
          { route: 'routes.cashGames', title: 'nav.cashGames', icon: 'cashGames' },
          { route: 'routes.pokerTournamentCalendar', title: 'nav.tournamentCalendar', badge: 'buy-tickets', icon: 'tournamentCal' },
          { route: 'routes.pokerNewYearsEve2025', title: 'nav.nye2025', scheduleKeyName: 'pokerNewYearsEve2025' },
          { route: 'tournaments.worldCupOfCards2025.schedule', title: 'tournaments.worldCupOfCards2025.title', scheduleKeyName: 'worldCupOfCards2025' },
          { route: 'tournaments.springBreakPowerWeeks2025.schedule', title: 'tournaments.springBreakPowerWeeks2025.title', scheduleKeyName: 'springBreakPowerWeeks2025' },
          { route: 'tournaments.wsopcPlaygroundSpring2025.schedule', title: 'tournaments.wsopcPlaygroundSpring2025.title', scheduleKeyName: 'wsopcPlaygroundSpring2025' },
          { route: 'tournaments.moneyMakerTour2025.schedule', title: 'tournaments.moneyMakerTour2025.title', scheduleKeyName: 'moneyMakerTour2025' },
          { route: 'routes.pastEvents', title: 'nav.pastEvents', icon: 'pastEvents' },
          { categoryTitle: true, route: 'routes.eatAndPlay', title: 'nav.eatAndPlay', badge: 'free', icon: 'eatAndPlay' },
          { route: 'pseudoRoutes.eatAndPlay.cashMenu.path', title: 'nav.cashGameMenu', icon: 'food' },
          { route: 'pseudoRoutes.eatAndPlay.tournamentMenu.path', title: 'nav.tournamentMenu', icon: 'tournament' },
          { categoryTitle: true, route: 'routes.pokerPromotions',title: 'nav.pokerPromotions', icon: 'pokerPromos' },
          { route: 'routes.tlb', title: 'nav.tlb', icon: 'pokerPromo', scheduleKeyName: 'pokerTlb' },
          { route: 'routes.multiMillionaireMaker2025', title: 'nav.multiMillionaireMaker2025', icon: 'pokerPromo', scheduleKeyName: 'multiMillionaireMaker2025' },
          { route: 'routes.irishOpen2025', title: 'nav.irishOpen2025', scheduleKeyName: 'irishOpen2025' },
          { route: 'routes.highHandJanuary2025', title: 'nav.highHandJanuary', icon: 'pokerPromo', scheduleKeyName: 'highHandJanuary2025' },
          { route: 'routes.highHandFebruary2025', title: 'nav.highHandFebruary2025', icon: 'pokerPromo', scheduleKeyName: 'highHandFebruary2025' },
          { route: 'routes.highHandMarch2025', title: 'nav.highHandMarch2025', icon: 'pokerPromo', scheduleKeyName: 'highHandMarch2025' },
          { route: 'highHands.highHandApril2025', title: 'highHandApril2025.title', icon: 'pokerPromo', scheduleKeyName: 'highHandApril2025' },
          { route: 'routes.titanTuesday2025', title: 'nav.titanTuesday2025', icon: 'pokerPromo', scheduleKeyName: 'titanTuesday2025' },
          { route: 'highHands.nationalPokerDay2025', title: 'nationalPokerDay2025.title', icon: 'pokerPromo', scheduleKeyName: 'nationalPokerDay2025' },
          { route: 'routes.mainEventMaynia2025', title: 'poker.mainEventMaynia2025.navTitle', icon: 'pokerPromo', scheduleKeyName: 'mainEventMaynia2025' },
          { route: 'routes.badBeatJackpot', title: 'nav.badBeatJackpot', icon: 'pokerPromo' },
          { route: 'routes.pokerPromotions', title: 'nav.allPokerPromotions', icon: 'pokerPromo' }
        ],
      },
      {
        title: 'nav.gamingMachines',
        mobileTitle: "nav.playGamingMachines",
        img: 'nav/egd-menu.jpg',
        imgAlt: 'nav.gamingMachines',
        items: [
          { categoryTitle: true, route: 'routes.egd', title: 'nav.gamingMachines', img: 'nav/gaming-machines.jpg', imgAlt: 'nav.gamingMachines', icon: 'egd'},
          { route: 'routes.egdGameList', title: 'nav.egdGameList', icon: 'gameList' },
          { route: 'routes.egdRecentJackpots', title: 'nav.recentJackpots', icon: 'gameList' },
          { categoryTitle: true, route: 'routes.electronicTableGames', title: 'nav.electronicTableGames', badge: 'new', icon:'tableGames' },
          { route: 'pseudoRoutes.electronicTableGames.blackJack.path', title: 'nav.blackJack', icon: 'blackJack' },
          { route: 'pseudoRoutes.electronicTableGames.roulette.path', title: 'nav.roulette', icon: 'roulette' },
          { route: 'pseudoRoutes.electronicTableGames.baccarat.path', title: 'nav.baccarat', icon: 'baccarat' },
          { route: 'pseudoRoutes.electronicTableGames.craps.path', title: 'nav.craps', icon: 'craps' },
          // { categoryTitle: true, route: 'routes.eatAndPlay', title: 'nav.eatAndPlay', badge: 'free', icon: 'eatAndPlay' },
          // { route: 'routes.eatAndPlay', title: 'nav.drinksMenu', icon: 'food' },
          // { route: 'routes.eatAndPlay', title: 'nav.bitesMenu', icon: 'drinks' },
          { categoryTitle: true, route: 'routes.egdPromotions', title: 'nav.gamingMachinePromotions', icon: 'egdPromos' },
          // { route: 'routes.freePlayFriday', title: 'nav.freePlayFriday', icon: 'egdPromo' },
          { route: 'routes.chineseNewYear2025', title: 'nav.chineseNewYear2025', icon: 'egdPromo', scheduleKeyName: 'chineseNewYear2025' },
          { route: 'routes.weeklyJackpotParty', title: 'nav.jackpotParty', icon: 'egdPromo' },
          { route: 'routes.spinAndSpoilMom2025', title: 'nav.spinAndSpoilMom2025', icon: 'egdPromo', scheduleKeyName: 'spinAndSpoilMom2025' },
          { route: 'routes.nuitElite', title: 'nav.nuitElite', icon: 'egdPromo', scheduleKeyName: 'nuitElite' },
          { route: 'routes.egdPromotions', title: 'nav.allGamingMachinePromotions', icon: 'egdPromo' }
        ]
      }
    ],
  },
  {
    title: 'nav.diningAndLounges',
    route: 'routes.diningLounges',
  },
  {
    title: 'nav.entertainment',
    route: 'routes.entertainment',
  },
  {
    title: 'nav.promotions',
    route: 'routes.promotions',
  },
  {
    title: 'nav.rewards',
    route: 'routes.rewards',
  },
  // {
  //   title: 'nav.shop',
  //   route: 'https://shop.playground.ca/',
  //   isExternal: true,
  // },
];
